import {ReactNode} from "react";

export default function NetworkFeeCom({icon, title, fee}: {
    icon: ReactNode,
    title: string,
    fee: {
        low: number,
        medium: number,
        high: number,
    }
}) {
    return <div className={` p-[20px]`}>
        <div className={`flex`}>
            {icon}
            <span className={`ml-[8px] text-[16px] font-semibold`}>{title}</span>
        </div>
        <div className={`text-[14px] mt-[24px]`}>
            <div className={`bg-[#FFFFFF1F] flex rounded-[8px] text-[#FFFFFF8F] p-[8px] items-center`}>
                <span className={`flex-1 flex justify-center`}>Low Priority</span>
                <span className={`flex-1 flex justify-center`}>Medium Priority</span>
                <span className={`flex-1 flex justify-center`}>High Priority</span>
            </div>
            <div className={`flex mt-[12px]`}>
                <span className={`flex-1 flex justify-center text-[16px]`}>{fee.low} <span
                    className={`text-[#FFFFFF5F] text-[16px] ml-[4px]`}>sat/vB</span></span>
                <span className={`flex-1 flex justify-center text-[16px]`}>{fee.medium} <span
                    className={`text-[#FFFFFF5F] text-[16px] ml-[4px]`}>sat/vB</span></span>
                <span className={`flex-1 flex justify-center text-[16px]`}>{fee.high} <span
                    className={`text-[#FFFFFF5F] text-[16px] ml-[4px]`}>sat/vB</span></span>
            </div>
        </div>
    </div>
}